import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/app-sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-8">
          <SidebarTrigger className="-ml-1" />
        </header>
        <main className="flex-1 px-8 py-4">{children}</main>
      </SidebarInset>
    </SidebarProvider>
  );
}
